/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateSkillInput = {
    name?: string | null | undefined;
    categoryId?: string | null | undefined;
    skillPersons?: Array<SkillPersonInputType | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type SkillPersonInputType = {
    personId?: string | null | undefined;
    skillId?: string | null | undefined;
    skillLevelId?: string | null | undefined;
};
export type createSkillMutationVariables = {
    input: CreateSkillInput;
};
export type createSkillMutationResponse = {
    readonly createSkill: {
        readonly skill: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly category: {
                    readonly id: string;
                } | null;
                readonly skillPersons: ReadonlyArray<{
                    readonly person: {
                        readonly id: string;
                        readonly role: {
                            readonly id: string;
                        } | null;
                        readonly department: {
                            readonly id: string;
                        } | null;
                        readonly active: boolean | null;
                        readonly permissions: ReadonlyArray<string | null> | null;
                    } | null;
                    readonly level: {
                        readonly id: string;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type createSkillMutation = {
    readonly response: createSkillMutationResponse;
    readonly variables: createSkillMutationVariables;
};



/*
mutation createSkillMutation(
  $input: CreateSkillInput!
) {
  createSkill(input: $input) {
    skill {
      node {
        id
        name
        category {
          id
        }
        skillPersons {
          person {
            id
            role {
              id
            }
            department {
              id
            }
            active
            permissions
          }
          level {
            id
          }
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSkillInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DepartmentType",
      "kind": "LinkedField",
      "name": "department",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillLevel",
  "kind": "LinkedField",
  "name": "level",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createSkillMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSkillPayload",
        "kind": "LinkedField",
        "name": "createSkill",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillTypeEdge",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Skill",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillPerson",
                    "kind": "LinkedField",
                    "name": "skillPersons",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createSkillMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSkillPayload",
        "kind": "LinkedField",
        "name": "createSkill",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillTypeEdge",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Skill",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillPerson",
                    "kind": "LinkedField",
                    "name": "skillPersons",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createSkillMutation",
    "operationKind": "mutation",
    "text": "mutation createSkillMutation(\n  $input: CreateSkillInput!\n) {\n  createSkill(input: $input) {\n    skill {\n      node {\n        id\n        name\n        category {\n          id\n        }\n        skillPersons {\n          person {\n            id\n            role {\n              id\n            }\n            department {\n              id\n            }\n            active\n            permissions\n          }\n          level {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '49ca062de637e13682b991f25b163818';
export default node;
